import { pidRegexStr } from '@fs/zion-pid'
import { type TreeId, type GroupId } from '@fs/zion-tree-types'

export const FAMILY_TABS = {
  ACTIVITIES: 'activities',
  CONTROLS: 'controls',
  DETAILS: 'details',
  MEMBERS: 'members',
} as const

export const RESEARCH_TREE_TABS = {
  CHAT: 'chat',
  DETAILS: 'details',
} as const

// Constrains :groupId to valid ID format — invalid groupIds fall through to the NotFound route
export const TREE_SETTINGS_PATH =
  `/:subPage(research-tree)/:groupId(${pidRegexStr as GroupId})/:tab(details|latest-changes|privacy|contributors)` as const

export const TREE_SETTINGS_NO_TAB_PATH = `/:subPage(research-tree)/:groupId(${pidRegexStr as GroupId})` as const

export const FAMILY_GROUP_PATH = `/:subPage(family)/:groupId?/:tab(activities|controls|details|members)?` as const

export const RESEARCH_TREE_PATH = `/:subPage(research-tree)/:groupId?/:tab(chat|details)?` as const

export const TREE_CHANGES_PATH = `/:subPage(research-tree)/:groupId(${pidRegexStr as GroupId})/changes` as const

export const SWITCH_TREE_PATH = `/switch/:treeId(${pidRegexStr as TreeId})` as const

export const CONNECT_CREATE_PATH = '/connect-create'

export const OLD_RESEARCHER_PAGE_PATH = '/researcher'

export const RESEARCH_TREE_LIST_PATH = '/research-tree'

export const FAMILY_GROUP_LIST_PATH = '/family'

export const TREES_PATH = '/trees'

export const CONNECT_CREATE_DONE_PATH = '/connect-create/done'
